window.addEventListener("load", function () {
    waitForElement("#oke-loyalty-welcome-header", (targetNode) => {
        initObserver(targetNode);
        moveCustomSection();
    });
});

function waitForElement(selector, callback, timeout = 10000) {
    const interval = 300;
    let elapsed = 0;

    const timer = setInterval(() => {
        const el = document.querySelector(selector);

        if (el) {
            clearInterval(timer);
            callback(el);
        }

        elapsed += interval;
        if (elapsed >= timeout) {
            clearInterval(timer);
            console.warn(selector + " not found within timeout");
        }
    }, interval);
}

function initObserver(targetNode) {
    const observer = new MutationObserver(() => {
        moveCustomSection();
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
}

function moveCustomSection() {
    const targetContainer = document.querySelector('#oke-loyalty-welcome-header');
    const customSection = document.querySelector('#custom-section');

    if (!customSection || !targetContainer) return;

    if (customSection && targetContainer) {
    targetContainer.after(customSection);
    }

    const reviewCarousel = document.querySelector('[data-oke-carousel]');
    const earnSection = document.querySelector('#oke-loyalty-earn');

    if (!reviewCarousel || !earnSection) return;

    if (reviewCarousel && earnSection) {
    earnSection.before(reviewCarousel);
    }
}